import React from "react";

import { getIcon } from "../../helpers/icons";
import Title from "../Title";

import style from "./style.module.css";

export default function IconLabel({ icon = "", label = "" }) {
    return (icon !== "" && label !== "") ? (
        <div className={style.categoryItem}>
            <i className={getIcon(icon)}></i>
            <Title tag="p">{label}</Title>
        </div>
    ) : null ;
}